import { defineStore } from "pinia";

export interface ImageData {
  path?: string;
  uploadPercent?: number;
  origen?: string;
  file?: File;
  raw?: File;
  blob?: File;
  url: string;
  description?: string;
  isDefault?: boolean;
  isProductClass?: boolean;
}

export interface UploadFileState {
  filesToUpload: ImageData[];
  filesToRemove: ImageData[];
}

export const useUploadFile = defineStore("uploadFile", {
  state: (): UploadFileState => ({
    filesToUpload: [],
    filesToRemove: [],
  }),
  actions: {
    setFilesToUpload(files: ImageData[] | null): void {
      this.filesToUpload = files ?? [];
    },
    addFilesToUpload(files: ImageData): void {
      this.filesToUpload.push(files);
    },
    removeFilesToUpload(file: ImageData): void {
      if (!this.filesToUpload || this.filesToUpload.length === 0) return;

      const indexSrc = this.filesToUpload.indexOf(file);
      if (indexSrc > -1) {
        this.filesToUpload.splice(indexSrc, 1);
      }
    },
  },
});
